import { NavigationLink } from './types';
import {
  analyticsAccessCheck,
  analyticsAccessCheckDeprecated,
  analyticsOceanAccessCheck,
  analyticsPortIntelAccessCheck,
  analyticsSustainabilityAccessCheck,
  analyticsTruckloadAccessCheck,
  analyticsTruckloadTrackingRcaAccessCheck,
  dashboardAccessCheck,
  initiateAccessCheck,
  initiateFTLMarketingAccessCheck,
  initiateMarketingSectionAccessCheck,
  networkLinkCheck,
  networkParentLink,
  networkTruckloadTrackingRcaAccessCheck,
  p44osAccessCheck,
} from './utils/guards';

const DashboardLink: NavigationLink = {
  iconName: 'dashboard',
  label: 'navigation.dashboard.title',
  url: '/results/dashboard',
  guard: dashboardAccessCheck,
};

const OverviewLink: NavigationLink = {
  iconName: 'dashboard',
  label: 'navigation.overview.title',
  url: '/results/dashboard',
  guard: dashboardAccessCheck,
};

const ResultsLink: NavigationLink = {
  iconName: 'track',
  label: 'navigation.track.title',
  url: '/results',
};

const VisibilityLink: NavigationLink = {
  iconName: 'track',
  label: 'navigation.visibility.title',
  url: '/results',
};

const InitiateLink: NavigationLink = {
  iconName: 'initiate',
  label: 'navigation.initiate.title',
  url: '/initiate',
  guard: initiateAccessCheck,
  subNavigation: [
    {
      iconName: 'initiate',
      label: 'navigation.initiate.shipments.title',
      url: '/initiate/shipment',
      guard: initiateAccessCheck,
    },
    {
      iconName: 'templates',
      label: 'navigation.initiate.templates.title',
      url: '/initiate/templates',
      guard: initiateAccessCheck,
    },
    {
      iconName: 'carriers',
      label: 'navigation.initiate.providers.title',
      url: '/initiate/providers',
      guard: initiateAccessCheck,
    },
  ],
};

const InitiateWithLTLLink: NavigationLink = {
  iconName: 'initiate',
  label: 'navigation.initiate.title',
  url: '/initiate',
  guard: initiateAccessCheck,
  subNavigation: [
    {
      iconName: 'initiate',
      label: 'navigation.initiate.ftlShipments.title',
      url: '/initiate/shipment',
      guard: initiateAccessCheck,
    },
    {
      iconName: 'templates',
      label: 'navigation.initiate.ftlTemplates.title',
      url: '/initiate/templates',
      guard: initiateAccessCheck,
    },
    {
      iconName: 'carriers',
      label: 'navigation.initiate.ftlProviders.title',
      url: '/initiate/providers',
      guard: initiateAccessCheck,
    },
    {
      iconName: 'initiate',
      label: 'navigation.initiate.ltl.title',
      url: '/vltl-ltl-rates',
    },
    {
      iconName: 'initiate',
      label: 'navigation.upsell.sailing_schedules.title',
      url: '/discover/sailing-schedules',
    },
  ],
};

const InitiateMarketingLink: NavigationLink = {
  iconName: 'initiate',
  label: 'navigation.initiate.title',
  url: '/initiate',
  guard: initiateFTLMarketingAccessCheck,
};

const InitiateMarketingLinkV2: NavigationLink = {
  iconName: 'initiate',
  label: 'navigation.initiate.title',
  url: '/initiate',
  guard: initiateMarketingSectionAccessCheck,
  subNavigation: [
    {
      iconName: 'initiate',
      label: 'navigation.upsell.ftl_initiate_upsell.title',
      url: '/initiate',
      guard: initiateFTLMarketingAccessCheck,
    },
    {
      iconName: 'initiate',
      label: 'navigation.initiate.ltl.title',
      url: '/vltl-ltl-rates',
    },
    {
      iconName: 'initiate',
      label: 'navigation.upsell.sailing_schedules.title',
      url: '/discover/sailing-schedules',
    },
  ],
};

const AnalyzeLink: NavigationLink = {
  iconName: 'analyze',
  label: 'navigation.analyze.title',
  url: '/analytics',
  guard: analyticsAccessCheck,
  subNavigation: [
    {
      iconName: 'analyze',
      label: 'navigation.analyze.ocean.title',
      url: '/analytics/ocean',
      guard: ({ user, flags }) => analyticsOceanAccessCheck({ user, flags }),
    },
    {
      iconName: 'analyze',
      label: 'navigation.analyze.portIntel.title',
      url: '/analytics/port-intel-v2',
      guard: ({ user, flags }) =>
        analyticsAccessCheck({ user, flags }) &&
        analyticsPortIntelAccessCheck({ user, flags }),
    },
    {
      iconName: 'analyze',
      label: 'navigation.analyze.sustainability.title',
      url: '/analytics/ocean-sustainability',
      guard: ({ user, flags }) =>
        analyticsAccessCheck({ user, flags }) &&
        analyticsSustainabilityAccessCheck({ user, flags }),
    },
    {
      iconName: 'analyze',
      label: 'navigation.analyze.truckload.title',
      url: '/analytics/truckload',
      guard: ({ user, flags }) =>
        analyticsAccessCheck({ user, flags }) &&
        analyticsTruckloadAccessCheck({ user, flags }),
    },
    {
      iconName: 'analyze',
      label: 'navigation.analyze.truckloadTrackingRca.title',
      url: '/analytics/tl-tracking-v2',
      guard: ({ user, flags }) =>
        analyticsAccessCheck({ user, flags }) &&
        analyticsTruckloadTrackingRcaAccessCheck({ user, flags }),
    },
  ],
};

const AnalyticsLink: NavigationLink = {
  iconName: 'analyze',
  label: 'navigation.analytics.title',
  url: '/analytics',
  guard: analyticsAccessCheck,
  subNavigation: [
    {
      iconName: 'analyze',
      label: 'navigation.analyze.ocean.title',
      url: '/analytics/ocean',
      guard: ({ user, flags }) => analyticsOceanAccessCheck({ user, flags }),
    },
    {
      iconName: 'analyze',
      label: 'navigation.analyze.portIntel.title',
      url: '/analytics/port-intel-v2',
      guard: ({ user, flags }) =>
        analyticsAccessCheck({ user, flags }) &&
        analyticsPortIntelAccessCheck({ user, flags }),
    },
    {
      iconName: 'analyze',
      label: 'navigation.analyze.sustainability.title',
      url: '/analytics/ocean-sustainability',
      guard: ({ user, flags }) =>
        analyticsAccessCheck({ user, flags }) &&
        analyticsSustainabilityAccessCheck({ user, flags }),
    },
    {
      iconName: 'analyze',
      label: 'navigation.analyze.truckload.title',
      url: '/analytics/truckload',
      guard: ({ user, flags }) =>
        analyticsAccessCheck({ user, flags }) &&
        analyticsTruckloadAccessCheck({ user, flags }),
    },
    {
      iconName: 'analyze',
      label: 'navigation.analyze.truckloadTrackingRca.title',
      url: '/network/root-cause-analysis',
      guard: ({ user, flags }) =>
        analyticsAccessCheck({ user, flags }) &&
        analyticsTruckloadTrackingRcaAccessCheck({ user, flags }),
    },
  ],
};

const NetworkLink: NavigationLink = {
  iconName: 'network',
  label: 'navigation.network.title',
  url: '/network/health',
  guard: networkParentLink,
  subNavigation: [
    {
      iconName: 'network',
      label: 'navigation.network.health.title',
      url: '/network/health',
      guard: ({ user, flags }) => networkLinkCheck({ user, flags }),
    },
    {
      iconName: 'analyze',
      label: 'navigation.analyze.truckloadTrackingRca.title',
      url: '/network/root-cause-analysis',
      guard: ({ user, flags }) =>
        analyticsAccessCheck({ user, flags }) &&
        networkTruckloadTrackingRcaAccessCheck({ user, flags }),
    },
  ],
};

const AnalyzeDeprecatedLink: NavigationLink = {
  iconName: 'analyze',
  label: 'navigation.analyze.title',
  url: '/analytics',
  guard: analyticsAccessCheckDeprecated,
};

const P44OsLink: NavigationLink = {
  iconName: 'p44os',
  label: 'navigation.p44OS.title',
  url: '/p44os',
  guard: p44osAccessCheck,
};

// Remove once `analyticsNavAmi1298` is removed
export const MOVEMENT_LINKS_analyticsNavAmi1298: NavigationLink[] = [
  { ...DashboardLink },
  { ...ResultsLink },
  { ...InitiateLink },
  { ...InitiateMarketingLink },
  { ...AnalyzeDeprecatedLink },
  { ...NetworkLink },
  { ...P44OsLink },
];

export const MOVEMENT_LINKS_WITH_UPSELL: NavigationLink[] = [
  { ...OverviewLink },
  { ...InitiateWithLTLLink },
  { ...InitiateMarketingLinkV2 },
  { ...VisibilityLink },
  { ...AnalyticsLink },
  { ...NetworkLink },
  { ...P44OsLink },
];

export const MOVEMENT_LINKS: NavigationLink[] = [
  { ...DashboardLink },
  { ...ResultsLink },
  { ...InitiateLink },
  { ...InitiateMarketingLink },
  { ...AnalyzeLink },
  { ...NetworkLink },
  { ...P44OsLink },
];

export const UPSELL_LINKS: NavigationLink[] = [
  {
    iconName: 'ecommerce_upsell',
    label: 'navigation.upsell.ecommerce.title',
    url: '/discover/ecommerce',
  },
  {
    iconName: 'facilities_upsell',
    label: 'navigation.upsell.facilities.title',
    url: '/discover/facilities',
  },
  {
    iconName: 'appointments_upsell',
    label: 'navigation.upsell.appointments.title',
    url: '/discover/appointments',
  },
];
